import GeneralService from "./GeneralService";
import { ApiKeyOrGetter } from "./GeneralService";
import { Component } from "react";

export class CompanyService extends Component {
  public static getCompany(loadingHandler: any, apiKey: ApiKeyOrGetter) {
    return GeneralService.get(
      "/company/",
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static updateCompany(
    payload: any,
    loadingHandler: any,
    apiKey: ApiKeyOrGetter
  ) {
    return GeneralService.put(
      "/company/",
      JSON.stringify(payload),
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static getAffiliatedCompanies(loadingHandler: any, apiKey: ApiKeyOrGetter) {
    return GeneralService.get(
      "/company/affiliated",
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static getAllCompanies(loadingHandler: any, apiKey: ApiKeyOrGetter) {
    return GeneralService.get(
      "/company/all",
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static getApplicationsByCompany(
    companyId: number | string,
    loadingHandler: any,
    apiKey: ApiKeyOrGetter
  ) {
    return GeneralService.get(
      `/company/${companyId}/applications`,
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static getIntentGroupsByCompany(
    companyId: number | string,
    loadingHandler: any,
    apiKey: ApiKeyOrGetter
  ) {
    return GeneralService.get(
      `/company/${companyId}/intent_groups`,
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static getOrganizationUsers(loadingHandler: any, apiKey: ApiKeyOrGetter) {
    return GeneralService.get(
      "/company/users",
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static inviteUserToOrganization(
    email: string,
    inviterName: string,
    loadingHandler: any,
    apiKey: ApiKeyOrGetter
  ) {
    return GeneralService.post(
      "/company/users/invite",
      JSON.stringify({ email, inviter_name: inviterName }),
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static ingestChatCompletion(
    companyId: number | string,
    body: {
      bucket: string;
      request_prefix: string;
      response_prefix: string;
      company_id: number;
    },
    loadingHandler: (val: boolean) => void = null,
    apiKey: ApiKeyOrGetter
  ) {
    return GeneralService.post(
      `/company/${companyId}/ingest`,
      JSON.stringify(body),
      loadingHandler,
      JSON,
      GeneralService.PROD_WEST_ENDPOINT,
      apiKey
    );
  }
}
